import { CommonModule } from '@angular/common';
import { Component, model, output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Checkbox, Icon } from '@millionshow/client-libs';

@Component({
  selector: 'app-registration-price-info',
  standalone: true,
  imports: [CommonModule, FormsModule, Checkbox, Icon],
  template: `
    <div class="flex flex-col gap-3">
      <p class="sb-aggro text-zinc-800">금액</p>
      <div class="flex flex-col gap-3">
        <div class="flex items-baseline gap-2">
          <span class="sb-aggro text-zinc-800 text-2xl">무료</span>
          <span class="text-zinc-400 font-medium text-sm line-through"
            >5,000원</span
          >
        </div>

        <div class="bg-zinc-50 p-4 rounded-lg flex flex-col gap-2">
          <p class="text-zinc-800 font-bold text-sm">확인해주세요</p>
          <p class="text-zinc-600 text-sm font-medium">
            접수 후 입장권 인쇄만 가져 현장 접수대에서 확인하시면 됩니다.
          </p>
          <p class="text-zinc-400 text-sm font-medium">
            *개인정보는 다음행사 안내의 목적으로 사용됩니다.
          </p>
        </div>
      </div>

      <div class="flex flex-col gap-3">
        <div [class.active]="allAgreed()" class="flex gap-2">
          <app-checkbox
            [ngModel]="allAgreed()"
            (ngModelChange)="allAgreed.set($event)" />
          <span class="text-zinc-800 font-medium">전체 동의하기</span>
        </div>

        <div class="w-full h-px bg-zinc-100"></div>

        <div [class.active]="isTermsAgreed()" class="flex gap-2 items-start">
          <app-checkbox
            [ngModel]="isTermsAgreed()"
            (ngModelChange)="isTermsAgreed.set($event)" />
          <span class="text-zinc-500 font-medium flex-1"
            ><span class="text-primary-500">(필수)</span> 개인정보이용동의</span
          >
          <app-icon
            name="material-symbols:chevron-right"
            class="size-5! text-zinc-300 cursor-pointer"
            (click)="openPolicy.emit('privacy')" />
        </div>

        <div [class.active]="isPrivacyAgreed()" class="flex gap-2 items-start">
          <app-checkbox
            [ngModel]="isPrivacyAgreed()"
            (ngModelChange)="isPrivacyAgreed.set($event)" />
          <span class="text-zinc-500 font-medium flex-1"
            ><span class="text-primary-500">(선택)</span> 마케팅활용동의</span
          >
          <app-icon
            name="material-symbols:chevron-right"
            class="size-5! text-zinc-300 cursor-pointer"
            (click)="openPolicy.emit('marketing')" />
        </div>
      </div>
    </div>
  `,
  styles: [
    `
      :host {
        display: block;
      }
    `,
  ],
})
export class RegistrationPriceInfoComponent {
  allAgreed = model(false);
  isTermsAgreed = model(false);
  isPrivacyAgreed = model(false);

  openPolicy = output<'privacy' | 'marketing'>();
}
